import {CommonMessages} from '../common.messages';

export const PanelClientsAddCorporateMessages = {
    GetCompanyFailed: {
        key: 'GetCompanyFailed',
        message: 'Error while communication with the server. Unable to get company details.'
    },
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Error while communication with the server. Unable to get countries'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Error while communication with the server. Invalid countries information.'
    },
    CompanyRegistrationFailed: {
        key: 'CompanyRegistrationFailed',
        message: 'Error while request processing. Unable to register company and it\'s representative.'
    },
    GetCompanyExtendedFailed: {
        key: 'GetCompanyExtendedFailed',
        message: 'Error while communication with the server. Cannot get available information about the newly registered company.'
    },
    TaxDetailsRegistrationFailed: {
        key: 'TaxDetailsRegistrationFailed',
        message: 'Error while request processing. Unable to register tax details.'
    },
    TaxDetailsUpdateFailed: {
        key: 'TaxDetailsUpdateFailed',
        message: 'Error while request processing. Unable to update tax details.'
    },
    VatDetailsUpdateFailed: {
        key: 'VatDetailsUpdateFailed',
        message: 'Error while request processing. Unable to update company VAT details.'
    },
    UpdateResidentialAddressFailed: {
        key: 'UpdateResidentialAddressFailed',
        message: 'Error while request processing. Unable to update company residential address.'
    },
    ResidentialAddressRegistrationFailed: {
        key: 'ResidentialAddressRegistrationFailed',
        message: 'Error while request processing. Unable to register company residential address.'
    },
    UpdateMailingAddressFailed: {
        key: 'UpdateMailingAddressFailed',
        message: 'Error while request processing. Unable to update company mailing address.'
    },
    MailingAddressRegistrationFailed: {
        key: 'MailingAddressRegistrationFailed',
        message: 'Error while request processing. Unable to register company mailing address.'
    },
    UploadDocumentFileForRegistrationFailed: {
        key: 'UploadDocumentFileForRegistrationFailed',
        message: 'Error while request processing. Unable to upload file for company document registration.'
    },
    DocumentRegistrationFailed: {
        key: 'DocumentRegistrationFailed',
        message: 'Error while request processing. Unable to register company document.'
    },
    UploadDocumentFileForUpdateFailed: {
        key: 'UploadDocumentFileForUpdateFailed',
        message: 'Error while request processing. Unable to upload file for company document update.'
    },
    UpdateDocumentFailed: {
        key: 'UpdateDocumentFailed',
        message: 'Error while request processing. Unable to update company document.'
    },
    UploadProofOfAddressDocumentFileForRegistrationFailed: {
        key: 'UploadProofOfAddressDocumentFileForRegistrationFailed',
        message: 'Error while request processing. Unable to upload file for proof of address document registration.'
    },
    ProofOfAddressDocumentRegistrationFailed: {
        key: 'ProofOfAddressDocumentRegistrationFailed',
        message: 'Error while request processing. Unable to register proof of address document.'
    },
    UploadProofOfAddressDocumentFileForUpdateFailed: {
        key: 'UploadProofOfAddressDocumentFileForUpdateFailed',
        message: 'Error while request processing. Unable to upload file for proof of address document update.'
    },
    UpdateProofOfAddressDocumentFailed: {
        key: 'UpdateProofOfAddressDocumentFailed',
        message: 'Error while request processing. Unable to update proof of address document.'
    },
    UpdateCompanyStatusFailed: {
        key: 'UpdateCompanyStatusFailed',
        message: 'Error while request processing. Unable to update company status.'
    },
    SendConfirmationEmailToEmployeeFailed: {
        key: 'SendConfirmationEmailToEmployeeFailed',
        message: 'Error while sending confirmation email to company legal representative.'
    },
    ...CommonMessages
};
